export const DOMAIN_KEY_HEADER_NAME = "domain-key";

export const ALLOWED_REDIRECT_HOST_SUFFIXES = [".alberta.ca"];

export const ALLOWED_REDIRECT_HOSTS = ["localhost", "127.0.0.1", "::1"];
